import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';
class GetStreetTargetPriceData extends BaseServiceRequest {
    constructor(osid, targetCurrencyCode) {
        super();
        super.addRequestUri("streetprice.pb");
        super.addRequestParameter("osid", osid.toString());
        super.addRequestParameter("tgc", targetCurrencyCode);
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "StreetTargetResponse";
    }
}

export default GetStreetTargetPriceData;